<template>
    <div id="asigmentsEvaluationsEstudent">
        <b-breadcrumb>
            <b-breadcrumb-item active>{{$t('evaluacion.label')}}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- <p class="label">{{$t('evaluacion.label')}}</p> -->
        <b-tabs id="tabEvaluationsEstudent" class="sm" >
            <b-tab :title="$t('title.9')"  :active="!tabEvaluation" @click="changeTab(false)">
                <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 24px;">
                    <div class="filters" v-if="flagHistory">
                        <h5>{{titleCourseHistory}}</h5>  
                    </div>
                    <div class="filters" v-else>
                       
                        <b-form-group style="width: 312px;" v-if="generalCourse">
                            <CustomSelect
                                @input="idValueSelectGeneralCourseAsigmments"
                                :options="optionsAllCourse"
                                value="id"
                                label="descripcion" 
                                :default="generalCourse.split('-')[2]"
                                :defaultValue="optionsAllCourse.length ? 0 : null"
                                @change="changeList()"
                                :firstOptionShow="false"
                            />
                            <!-- <b-form-select v-model="generalCourse" :options="optionsCourse" @change="changeList" style="width: 312px;">
                            
                            </b-form-select> -->
                        </b-form-group>
                    </div>
                    <!-- Issue #4: completed courses leave this live view; point students to the
                         Course History section where completed courses + evaluations stay available. -->
                    <router-link
                        to="/student/historial-cursos"
                        class="link noBorder"
                        v-if="!flagHistory"
                    >
                        {{ $i18n.locale === 'en' ? 'View completed courses & history' : 'Ver cursos completados e historial' }}
                    </router-link>
                </div>
                <b-table
                hover 
                :items="items1" 
                :fields="field1"  
                :busy="isBusy"   
                :show-empty="true"
                id="table-task"  
                :tbody-transition-props="transProps"
                :empty-text="$t('reusables.empty-text')"
                >
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> {{$t('ClassRequest.Loading')}}...</strong>
                        </div>
                    </template>
                    <template #cell(files)="data">
                        <div v-if="flagHistory">
                            <div v-if="data.item.files!=0">
                                <span>
                                        <p>{{`${data.item.files} ${data.item.files == 1 ? $t('evaluations.index.file') : $t('evaluations.index.files')}`}}</p>
                                <p>{{data.item.comments}}</p>
                                </span>
                            
                            </div>
                            <div v-else>
                                -
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="data.item.files!=0">
                                <span v-if="flagPlant">
                                    <a  @click="linkFileUpload(data.item)" class="link noBorder">{{`${data.item.files} ${data.item.files == 1 ? $t('evaluations.index.file') : $t('evaluations.index.files')}`}}</a>
                                    <p>{{data.item.comments}}</p>
                                </span>
                                <span v-else>
                                    <p  >{{`${data.item.files} ${data.item.files == 1 ? $t('evaluations.index.file') : $t('evaluations.index.files')}`}}</p>
                                    <p>{{data.item.comments}}</p>
                                </span>
                            </div>
                            <b-button v-else @click="linkFileUpload(data.item)" :disabled="!flagPlant" class="btn btn-primary">
                                <icon name="cloud-file" />
                                {{$t('evaluacion.buttons.subir-tarea')}}
                            </b-button>
                        </div>
                   
                        <!-- <p>{{$t('evaluacion.text.10')}}</p> -->
                    </template>
                    <template #cell(review)="data">
                        <div v-if="data.value" class="table-icon" @click="goRevision(data.item)">
                            <icon name="revision" />
                            <span  v-if="data.item.flagRead" class="dot" style="width: 12px; height: 12px;top: -6px;"></span>
                        </div>
                         <div v-else>
                            <span>-</span>
                        </div>
                    </template>
                </b-table>
              
                <div class="overflow-auto content-pagination">
                    <b-pagination
                    v-model="currentPageEval"
                    :total-rows="totalRowsEval"
                    :per-page="perPageEval"
                  
                    aria-controls="table-task"
                    ></b-pagination>
                    {{currentPageEval}}-{{perPageEval}} / {{totalRowsEval > 0 ?  totalRowsEval : totalRowsEval-1}}  {{$t('ClassRequest.text.3')}}
                </div>
            </b-tab>
            <b-tab :title="$t('title.8')"  :active="tabEvaluation" @click="changeTab(true)">
                <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 24px;">
                    <div class="filters" v-if="flagHistory">
                        <h5>{{titleCourseHistory}}</h5>  
                    </div>
                    <div class="filters" v-else>
                        <b-form-group style="width: 312px;"  v-if="generalCourse">
                            <CustomSelect
                                @input="idValueSelectGeneralCourseEvaluations"
                                :options="optionsCourse"
                                value="id"
                                label="descripcion" 
                                :default="generalCourse.split('-')[2]"
                                :defaultValue="optionsCourse.length ? 0 : null"
                                @change="changeList()"
                                :firstOptionShow="false"
                            />
                            <!-- <b-form-select v-model="generalCourse" :options="optionsCourse" @change="changeList" style="width: 312px;">
                      
                        </b-form-select> -->
                    </b-form-group>
                    </div>
                    <b-row class="resultNote" v-if="typeSubject==1">
                        <b-col class="justify-content-end">
                            <h6>{{$t('evaluacion.resultNote.1')}}</h6>
                            <span>{{valuePercentage ? valuePercentage : '-'}}</span>
                        </b-col>
                        <b-col class="justify-content-end">
                            <p :style="{color:idState == 1 ? '#8DBD65' : idState == 2 ? '#D4263A' : '#FDD51C'}">{{valueState}}</p> 
                        </b-col>
                    </b-row>
                    <b-row class="resultNote" style="width: 456px;" v-if="typeSubject==2">
                        <b-col>
                            <h6>{{$t('evaluacion.resultNote.2')}}  </h6>
                            <span> {{valuePercentage ? valuePercentage : '-'}} (nivel {{nameLevel}})
                                <icon name="info" title="text" v-b-tooltip.hover style="position: relative; top: -3px; left: 10px" />
                            </span>
                        </b-col>
                    </b-row>
                </div>
               
                <b-table hover 
                    :items="items1" 
                    :fields="field1" 
                    :busy="isBusy"  
                  
                    :show-empty="true"
                    id="table-evaluation"  
                    :tbody-transition-props="transProps"
                    :empty-text="$t('reusables.empty-text')"
                >
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong> {{$t('ClassRequest.Loading')}}...</strong>
                        </div>
                    </template>
                      <template #cell(files)="data">
                        <div v-if="flagHistory">
                            <div v-if="data.item.files!=0">
                                <span>
                                        <p  >{{`${data.item.files} ${data.item.files == 1 ? $t('evaluations.index.file') : $t('evaluations.index.files')}`}}</p>
                                <p>{{data.item.comments}}</p>
                                </span>
                            
                            </div>
                            <div v-else>
                                -
                            </div>
                        </div>
                        <div v-else>
                               <div  v-if="data.item.files!=0">
                               <span v-if="flagPlant">
                                    <a   @click="linkFileUpload(data.item)" class="link noBorder">{{`${data.item.files} ${data.item.files == 1 ? $t('evaluations.index.file') : $t('evaluations.index.files')}`}}</a>
                            <p>{{data.item.comments}}</p>
                            </span>
                            <span v-else>
                                    <p  >{{`${data.item.files} ${data.item.files == 1 ? $t('evaluations.index.file') : $t('evaluations.index.files')}`}}</p>
                            <p>{{data.item.comments}}</p>
                            </span>
                        

                           
                        </div>

                        
                        <b-button  v-else @click="linkFileUpload(data.item)"  :disabled="!flagPlant"  class="btn btn-primary">
                            <icon name="cloud-file" />
                             {{$t('evaluacion.buttons.subir-evaluacion')}}
                        </b-button>
                        </div>
                     
                        <!-- <p>{{$t('evaluacion.text.10')}}</p> -->
                    </template>
                  
                    <template #cell(review)="data">
                        <div v-if="data.value" class="table-icon" @click="goRevision(data.item)">
                            <icon name="revision" />
                            <span  v-if="data.item.flagRead" class="dot" ></span>
                        </div>
                         <div v-else>
                            <span>-</span>
                        </div>
                    </template>
                </b-table>
              
                <div class="overflow-auto content-pagination">
                    <b-pagination
                        v-model="currentPageEval"
                        :total-rows="totalRowsEval"
                        :per-page="perPageEval"
                        aria-controls="table-evaluation"
                    ></b-pagination>
                    {{currentPageEval}}-{{perPageEval}} / {{totalRowsEval > 0 ?  totalRowsEval : totalRowsEval-1}}   {{$t('ClassRequest.text.3')}}
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
const lang = localStorage.getItem('lang') || 'es';


import CustomSelect from "@/components/form/select";
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
  export default {
    components:{
        CustomSelect
    },
    data() {
      return {
        titleCourseHistory : '',
        flagHistory :false,
        valuePercentage: '',
        isBusy : false,
        valueState : '',
        idState: 0,
        currentPageEval: 1,
        perPageEval : 10,
        nameLevel : '',
        totalRowsEval:  0,
        tabEvaluation: false ,
        generalCourse:null,
        optionsCourse:[],
        optionsAllCourse: [],
        typeSubject :null,
        transProps: {
            name: 'flip-list'
        },
        // hePassed:0,
        // section:0,
        field1:[
            {key:'module' , label:this.$t('evaluations.index.table-th.7')},
            {key:'files' , label:this.$t('evaluations.index.table-th.2')},
            {key:'date' , label:this.$t('evaluations.index.table-th.3')},
            {key:'calification' , label:this.$t('evaluations.index.table-th.4')},
            {key:'review' , label:this.$t('evaluations.index.table-th.5')},
            {key:'teacher' , label:this.$t('evaluations.index.table-th.6')},
        ],
        items1: [ ],
        generalCourseTabTarea:null,
        generalCourseTabEvaluacion:null,
      }
    },
    created(){
        if(this.$route.params.id == undefined){
            if(this.$route.params.tabEvaluation != null){
                this.tabEvaluation = this.$route.params.tabEvaluation;
            }

            this.flagHistory = false;

            if(this.$route.params.course != null && !this.$route.params.tabEvaluation){
                this.getListCombo();
                this.generalCourseTabTarea = this.$route.params.course;
                this.idValueSelectGeneralCourseAsigmments(this.$route.params.course);
            }else if(this.$route.params.course != null && this.$route.params.tabEvaluation){
                this.getListCombo();
                this.generalCourseTabEvaluacion = this.$route.params.course;
                this.idValueSelectGeneralCourseEvaluations(this.$route.params.course);
            }else{
                this.getListCombo();
            }

        }else{
            this.flagHistory = true;
            this.getListCoursesHistory();  
        }



    },
    watch:{
        currentPageEval: {
			handler: function(newVal, oldVal) {
				this.getListPersonPage();
			}
		},
    },
    computed:{
        flagPlant : {
            get(){
                return this.$store.state.datosSidebar.flagActivePlan
            }
        },
        User: {
            get() {
                return this.$store.state.user;
            },
        }
      
    },
    methods:{
        getListCoursesHistory(){
            this.isBusy = true;
             let data = {
                id: this.$route.params.id,
                flagEvaluation :this.tabEvaluation ,
                page : this.currentPageEval,
                size : this.perPageEval,
                timezone: this.$store.state.user.timeZoneName
            }
    
            this.items1 = []
            baseInstanceAxios
            .get(`${this.apiURL}/resources/PersonsAssignmentsEvaluations/GetPersonsAssignmentsEvaluationsBySubjectsHistory`,{
                params : data
            } )
            .then(response => {
               
                if(response.data.entity){
                    this.titleCourseHistory = lang == "es" ? response.data.entity.strSubjectName : response.data.entity.strSubjectName_EN;
                    this.valueState =  response.data.entity.stateSubject ?  response.data.entity.stateSubject.name : '';
                    this.idState = response.data.entity.stateSubject ? response.data.entity.stateSubject.value : 0;
                    this.nameLevel  = response.data.entity.level ?  response.data.entity.level.abbreviation : '';
                    this.valuePercentage = response.data.entity.entityPersonsAssignmentEvaluation ?  response.data.entity.entityPersonsAssignmentEvaluation.strScore : '';
                    this.totalRowsEval = response.data.entity.personsAssignmentsEvaluations.rows;
                    this.typeSubject = response.data.entity.typeSubject;
                    this.items1 = response.data.entity.personsAssignmentsEvaluations.list.map(element =>({
                        id : element.id,
                        personId: element.personId,
                        strModule : lang == "es" ? element.strModule : element.strModule_EN,
                        module: response.data.entity.typeSubject == 1 ? element.module > 0 ? element.module : '-' : '-' ,
                        files:element.fileCount,
                        date:element.strSubmittedDateHour ? element.strSubmittedDateHour : '-',
                        calification:element.score ? element.strScore : '-',
                        comments : element.studentComments,
                        review:element.flagReview,
                        teacher:element.strPersonTeacher,
                        flagRead : element.flagRead,
                        
                    }))
                 
                    this.isBusy = false;
                }
            
         
            });
            
        },
        idValueSelectGeneralCourseAsigmments(event){
            this.generalCourse = event;
            this.getAssignment();
        },
        getAssignment(){
            if(this.generalCourse){
                this.typeSubject = parseInt(this.generalCourse.split('-')[1])
            }else{
                this.typeSubject = null
            }
        },
        idValueSelectGeneralCourseEvaluations(event){
            this.generalCourse = event;
            this.getAssignment();
        },
        linkFileUpload(item){
            const data = {
                id: item.id , 
                flagEdited: true, 
                course: this.generalCourse , 
                flagEvaluation: this.tabEvaluation,
                module: {
                    id: item.module,
                    strModule:item.strModule
                }   
            }


            this.$router.push({name : 'evaluation-file-upload', params : data}).catch(err => {}); 
        },
        changeList(){
            this.currentPageEval = 1,
            this.totalRowsEval = 0,
            this.getListPerson();
        },
        changeTab(flag){
             this.isBusy = true;
            console.log("changeTab")
            this.tabEvaluation = flag;
            this.currentPageEval = 1;
            this.totalRowsEval = 0;
            
            if(this.flagHistory){
                this.getListCoursesHistory();
                
            }else{
                if(this.tabEvaluation){
                    this.generalCourseTabTarea = this.generalCourse;
                    this.generalCourse = this.generalCourseTabEvaluacion;
                }else{
                    this.generalCourseTabEvaluacion = this.generalCourse;
                    this.generalCourse = this.generalCourseTabTarea;
                }
                console.log("this.generalCourse: " + this.generalCourse)
                this.getListCombo();
            }
             this.isBusy = false;
        },
        getListCombo(){
            let data = {
                PersonStudentId : this.User.personStudentId,
                FlagEvaluation : this.tabEvaluation 
            }

            baseInstanceAxios
                .get(`${this.apiURL}/Resources/Subjects/ComboSubjectsByGroupPersonId`,{
                    params : data
                } )
                .then(response => {
                    
                    if(response.data.list.length>0){
                        if((!this.tabEvaluation && this.generalCourseTabTarea == null) ||  (this.tabEvaluation && this.generalCourseTabEvaluacion == null) ){
                            console.log("setear generalCourse from api")
                            this.generalCourse =  response.data.list[0].id+"-"+response.data.list[0].valor+"-"+ (lang == "es" ?  response.data.list[0].descripcion : response.data.list[0].descripcion_EN )
                        }
                        
                        let options = response.data.list.map(element =>({
                            id: element.id+"-"+element.valor+"-"+ (lang == "es" ? element.descripcion : element.descripcion_EN),
                            descripcion: lang == "es" ? element.descripcion : element.descripcion_EN ,
                            valor: element.valor
                        }));

                        this.optionsCourse = options.filter(x => x.valor != 3);
                        this.optionsAllCourse = options;
                        
                        this.getAssignment();
                        this.getListPerson();
                         
                    }
                });
        },
        getListPersonPage(){
         
            this.isBusy = true;
            let data = {
                personStudentid:  this.User.personStudentId,
                groupRegisterSubjectId: parseInt(this.generalCourse.split('-')[0]),
                typeSubject: parseInt( this.generalCourse.split('-')[1]),
                flagEvaluation :this.tabEvaluation ,
                page : this.currentPageEval,
                size : this.perPageEval,
                timezone: this.$store.state.user.timeZoneName
            }
            this.items1 = []
            baseInstanceAxios
            .get(`${this.apiURL}/resources/PersonsAssignmentsEvaluations/ListPersonsAssignmentsEvaluationsBySubjects`,{
                params : data
            } )
            .then(response => {
            
                if(response.data){
                 
                    this.items1 = response.data.list.map(element =>({
                        id : element.id,  
                        personId: element.personId,
                        strModule: lang == "es" ? element.strModule : element.strModule_EN,
                        module:  parseInt(this.generalCourse.split('-')[1]) == 1 ? element.module > 0 ? element.module : '-' : '-' ,
                        files:element.fileCount,
                        date:element.strSubmittedDateHour ? element.strSubmittedDateHour : '-',
                        calification:element.score ? element.strScore : '-',
                        comments : element.studentComments,
                        review:element.flagReview,
                        teacher:element.strPersonTeacher,
                        flagRead : element.flagRead,
                        
                    }))
                  
                    if(response.data.list.length < this.perPageEval){
                        if(parseInt(this.generalCourse.split('-')[1]) == 2 || parseInt(this.generalCourse.split('-')[1]) == 3){
                              this.items1.push({
                                id : 0,
                                personId: 0,
                                strModule : null,
                                module:  '-'  ,
                                files:0,
                                date: '-',
                                calification: '-',
                                comments :'-',
                                review:false,
                                teacher:'-',
                                flagRead : false,
                                
                            })
                        }

                        if(!this.tabEvaluation){
                            if(parseInt(this.generalCourse.split('-')[1]) == 1){
                                this.items1.push({
                                    id : 0,
                                    personId: 0,
                                    strModule : null,
                                    module: '-' ,
                                    files:0,
                                    date: '-',
                                    calification: '-',
                                    comments :'-',
                                    review:false,
                                    teacher:'-',
                                    flagRead : false,
                                   
                                })
                            } 
                       }
                   
                    }
                     this.isBusy = false;
                }
         
            });  
        },
        getListPerson(){
           
            this.isBusy = true;
             let data = {
                personStudentid:  this.User.personStudentId,
                groupRegisterSubjectId: parseInt(this.generalCourse.split('-')[0]),
                typeSubject: parseInt(this.generalCourse.split('-')[1]),
                flagEvaluation :this.tabEvaluation ,
                page : this.currentPageEval,
                size : this.perPageEval,
                timezone: this.$store.state.user.timeZoneName
            }
            this.items1 = []
            baseInstanceAxios
            .get(`${this.apiURL}/resources/PersonsAssignmentsEvaluations/GetPersonsAssignmentsEvaluationsBySubjects`,{
                params : data
            } )
            .then(response => {
                //console.log("response.data.entity: ",response.data.entity)
                if(response.data.entity){
                    this.valueState =  response.data.entity.stateSubject ?  response.data.entity.stateSubject.name : '';
                    this.idState = response.data.entity.stateSubject ? response.data.entity.stateSubject.value : 0;
                    this.nameLevel  = response.data.entity.level ?  response.data.entity.level.abbreviation : '';
                    this.valuePercentage = response.data.entity.entityPersonsAssignmentEvaluation ?  response.data.entity.entityPersonsAssignmentEvaluation.strScore : '';
                    this.totalRowsEval = response.data.entity.personsAssignmentsEvaluations.rows;
                    this.items1 = response.data.entity.personsAssignmentsEvaluations.list.map(element =>({
                        id : element.id,
                        personId: element.personId,
                        strModule :  lang == "es" ? element.strModule : element.strModule_EN,
                        module: parseInt(this.generalCourse.split('-')[1]) == 1 ? element.module > 0 ? element.module : '-' : '-' ,
                        files:element.fileCount,
                        date:element.strSubmittedDateHour ? element.strSubmittedDateHour : '-',
                        calification:element.score ? element.strScore : '-',
                        comments : element.studentComments,
                        review:element.flagReview,
                        teacher:element.strPersonTeacher,
                        flagRead : element.flagRead,
                        
                    }))

                    
                 
                    if(response.data.entity.personsAssignmentsEvaluations.list.length < this.perPageEval){
                        if(parseInt(this.generalCourse.split('-')[1]) == 2 || parseInt(this.generalCourse.split('-')[1]) == 3){
                              this.items1.push({
                                id : 0,
                                personId: 0,
                                strModule : null,
                                module:  '-' ,
                                files:0,
                                date: '-',
                                calification: '-',
                                comments :'-',
                                review:false,
                                teacher:'-',
                                flagRead : false,
                                
                            })
                        }

                        if(!this.tabEvaluation){
                            if(parseInt(this.generalCourse.split('-')[1]) == 1){
                                this.items1.push({
                                    id : 0,
                                    personId: 0,
                                    strModule : null,
                                    module: '-' ,
                                    files:0,
                                    date: '-',
                                    calification: '-',
                                    comments :'-',
                                    review:false,
                                    teacher:'-',
                                    flagRead : false,
                                    
                                })
                            } 
                        }

                      
                      
                    }else{
                     
                        if(!this.tabEvaluation ){
                            if(response.data.entity.personsAssignmentsEvaluations.list.length == this.perPageEval){
                              this.totalRowsEval++
                            }
                        }

                         if(this.tabEvaluation){
                           
                             if(parseInt(this.generalCourse.split('-')[1]) != 1){
                          
                                if(response.data.entity.personsAssignmentsEvaluations.list.length == this.perPageEval){
                                    this.totalRowsEval++
                                }
                             }
                        }

                      
                    }

                    this.isBusy = false;

                    if(this.generalCourseTabTarea != null && !this.tabEvaluation){
                        this.generalCourse = "";
                        let tmp = this.generalCourseTabTarea;
                        this.generalCourseTabTarea = "";
                        setTimeout(() => {
                            this.generalCourse = tmp;
                            this.generalCourseTabTarea = null;
                        }, 100);
                        
                    }

                    if(this.generalCourseTabEvaluacion != null && this.tabEvaluation){
                        this.generalCourse = "";
                        setTimeout(() => {
                            this.generalCourse = this.generalCourseTabEvaluacion;
                            this.generalCourseTabEvaluacion = null
                        }, 100);
                        
                    }   
                }

                
                
            });
        },

        
        // goHePassed(value){
        //     this.hePassed=1;
        //     if(value==2){
        //         this.section=1
        //     }else if(value==1){
        //         this.section=2
        //     }else{
        //         this.section=3
        //     }

        // },

        goRevision(item){
            const data = {
                id : item.id,
                historyId : this.$route.params.id,
            }
      
            this.$router.push({
                name : 'evaluation-review',
                params : data
            }).catch(err => {}); 
        }
    }
  }
</script>